"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-prompts.disabled': 'La función de prompts avanzados no está disponible en su plan actual.',
};
